import {ReactElement} from "react";
import {styled} from "styled-components";

import Logo from "@/assets/logoComplet.svg?react";
import {BlocContent} from "@/components/BlocContent/BlocContent";
import {LogContext, LogContextType} from "@/context/LogContex";
import {quicksandBold} from "@/GlobalStyle";
import {quicksandSemiBold} from "@/GlobalStyle";
import {breakpoints} from "@/GlobalStyle";
import {shadowButton} from "@/GlobalStyle";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";

const BlocContentStyled = styled(BlocContent)`
  width: 80%;
  align-self: center;
  margin: 10% auto 0;
  @media (max-width: ${breakpoints.sm}) {
  }
`;

const LogoStyled = styled(Logo)`
  height: 10rem;
  margin: 20px auto;
  display: block;
  @media (max-width: ${breakpoints.sm}) {
    height: 6rem;
  }
`;

const TextStyled = styled.p`
  text-align: center;
  color: ${({theme}) => theme.colors.darkPrimary};
  margin: 30px 0;
  font-size: 1.25rem;
  ${quicksandBold}
  @media (max-width: ${breakpoints.sm}) {
    font-size: 1rem;
  }
`;
const ButtonStyled = styled.button`
  width: 80%;
  background-color: ${({theme}) => theme.colors.mediumSecondary};
  border: none;
  display: block;
  margin: 0 auto 20px;
  color: white;
  ${quicksandSemiBold}
  font-size: 1.75rem;
  padding: 25px 0px;
  ${shadowButton}
  &:hover {
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
  }
  @media (max-width: ${breakpoints.sm}) {
    font-size: 1.25rem;
  }
`;

const LinkStyled = styled.a`
  color: ${({theme}) => theme.colors.mediumSecondary};
  ${quicksandSemiBold}
  font-size: 1.25rem;
  text-align: center;
  margin: 40px auto;
  display: block;
  @media (max-width: ${breakpoints.sm}) {
    font-size: 1rem;
  }
`;

export function Connexion(): ReactElement {
  const {handleLogin} = useGetContext<LogContextType>(LogContext, "LogContext");

  return (
    <BlocContentStyled data-testid="BlocContentStyled">
      <LogoStyled data-testid="LogoStyled" />
      <TextStyled data-testid="TextStyled">
        Vous devez être connecté à votre compte OKTA pour accéder à
        l’application
      </TextStyled>
      <ButtonStyled data-testid="ButtonStyled" onClick={() => handleLogin()}>
        Je me connecte
      </ButtonStyled>
      <LinkStyled
        href="https://cofaq.okta.com/app/UserHome"
        data-testid="LinkStyled">
        Retour sur univers Cofaq
      </LinkStyled>
    </BlocContentStyled>
  );
}
